export { FaqCategoryPage } from "./FaqCategoryPage"
